<template>
    <div class="notification mtb-5" v-if="campaign.affiliate_link">
        Your link: <strong>{{ campaign.affiliate_link.short_url }}</strong>
    </div>
</template>
<script>
    export default {

        /**
         * The component name
         *
         * @type {string}
         */
        name: 'AffiliateLinkNotification',

        /**
         * The component properties
         *
         * @type {object}
         */
        props: {

            /**
             * The campaign
             */
            campaign: {
                type: Object,
                required: true
            },
        }
    }
</script>